import { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import Drawer, { DrawerHeader, DrawerFooter } from 'common/components/drawer';
import { FormDrawer } from 'common/components/drawer';
import { useForm, useActions, useFormState } from 'utils/hooks';
import * as authorizationTypes from 'store/authorization/actions';
import { FormBody } from 'common/components/drawer';
import selectDataFromState from 'utils/selectDataFromState';
import { isValidPassword } from 'common/components/general/PasswordValidation';
import { selectAccountIsAdmin } from 'store/account/selectors';
import { useSelector } from 'react-redux';
import config from './config';
import Body from './Body';

const AuthorizationForm = ({ drawer, active, refetchData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updateAuthorization, createAuthorization] = useActions([
    authorizationTypes.updateAuthorization,
    authorizationTypes.createAuthorization
  ]);
  const { formState, loadValues, handleSubmitError, resetForm, collectValues } = useForm(config);
  const { setFieldError } = useFormState(formState);

  const { isOpen } = drawer;
  const accountIsAdmin = useSelector(selectAccountIsAdmin);

  useEffect(() => {
    if (active && isOpen) {
      const params = { ...active };

      const initialValues = selectDataFromState(params, config);

      loadValues({ ...initialValues });
    } else if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  const submit = async () => {
    const values = collectValues();

    if (!values) return;

    const { is_admin, ...rest } = values;
    const params = { ...rest, table: 'authorization', id: active ? active.id : undefined };

    if (params?.password !== params?.confirm_password) {
      setFieldError('confirm_password', "Passwords don't match.");
      return;
    }

    if (!isValidPassword(params?.password)) {
      setFieldError('password', 'Invalid password.');
      return;
    }

    if (accountIsAdmin) params.is_admin = is_admin;

    setIsSubmitting(true);
    try {
      if (active) {
        await updateAuthorization(params);

        drawer.close();
      } else {
        await createAuthorization(params);

        drawer.close();
        resetForm();
        refetchData();
      }
    } catch (error) {
      handleSubmitError(error);
    }

    setIsSubmitting(false);
  };

  return (
    <Drawer {...drawer} className="table-drawer">
      <DrawerHeader className="border-bottom pb-4">
        {active ? 'Edit ' + active.name : 'Create User'}
      </DrawerHeader>

      <FormDrawer>
        <FormBody>
          <Body formState={formState} accountIsAdmin={accountIsAdmin} />
        </FormBody>
      </FormDrawer>

      <DrawerFooter className="d-flex justify-content-end p-3">
        <Button
          color="cancel"
          className="px-0 py-1 me-4"
          onClick={() => drawer.close()}
          disabled={isSubmitting}
        >
          CANCEL
        </Button>
        <Button onClick={submit} disabled={isSubmitting} color="primary" className="px-4">
          SAVE
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

export default AuthorizationForm;
